import * as z from 'zod';

export const ParticipantId = z.string();
export type ParticipantId = z.infer<typeof ParticipantId>;

export const ParticipantChallengeData = z.object({
  challengeGoal: z.number().optional(),
  averageBeforeChallenge: z.number().optional(),
  expenseAmount: z.number().optional(),
  emoji: z.string().optional(),
  color: z.string().optional(),
});

export type ParticipantChallengeData = z.infer<typeof ParticipantChallengeData>;

export const Participant = z.object({
  memberId: z.string(),
  participantId: ParticipantId,
  firstName: z.string(),
  challengeData: ParticipantChallengeData,
  challengeId: z.string(),
  customerId: z.number(),
  isMe: z.boolean().optional(),
});
export type Participant = z.infer<typeof Participant>;

export const ParticipantCircle = z.object({
  emoji: z.string().optional(),
  color: z.string().optional(),
});
export type ParticipantCircle = z.infer<typeof ParticipantCircle>;
